module.exports = __webpack_public_path__ + "img/iterative-process-diagram.02b633a3.png";